import {
  Button,
  ButtonProps,
  IconButton,
  IconButtonProps,
  Menu,
  MenuItem,
  MenuProps,
} from '@mui/material'
import React, { useState } from 'react'

type Option = {
  key?: string
  label: string
  onClick: () => void
  hide?: boolean
} | null

type IconMenuProps = {
  isIcon: true
  iconTrigger: React.ReactNode
  textTrigger?: string
  slotProps?: {
    trigger?: IconButtonProps
    menu?: Partial<MenuProps>
  }
  options: Option[]
  onOpen?: () => void
  onClose?: () => void
}

type ButtonMenuProps = {
  isIcon?: false
  textTrigger: string
  iconTrigger?: React.ReactNode
  slotProps?: {
    trigger?: ButtonProps
    menu?: Partial<MenuProps>
  }
  options: Option[]
  onOpen?: () => void
  onClose?: () => void
}

type CustomMenuProps = IconMenuProps | ButtonMenuProps

const CustomMenu: React.FC<CustomMenuProps> = ({
  isIcon,
  iconTrigger,
  textTrigger,
  slotProps,
  options,
  onClose,
  onOpen,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    onOpen?.()
  }
  const handleClose = () => {
    setAnchorEl(null)
    onClose?.()
  }

  return (
    <>
      {isIcon ? (
        <IconButton
          onClick={handleClick}
          size="small"
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          color="inherit"
          sx={{
            color: 'inherit',
            ...(slotProps?.trigger?.sx || {}),
          }}
          {...(slotProps?.trigger as IconButtonProps)}
        >
          {iconTrigger}
        </IconButton>
      ) : (
        <Button
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          {...(slotProps?.trigger as ButtonProps)}
        >
          {textTrigger}
        </Button>
      )}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        {...slotProps?.menu}
      >
        {options
          .filter(Boolean)
          .filter(option => !option.hide)
          .map((option, index) => (
            <MenuItem
              key={option.key || index}
              onClick={() => {
                option.onClick()
                handleClose()
              }}
            >
              {option.label}
            </MenuItem>
          ))}
      </Menu>
    </>
  )
}

export default CustomMenu
